module.exports = __webpack_public_path__ + "static/media/cdh-profile-logo.846ec046.png";